import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ae85b7e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "negotiation_form container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "text-primary mb-0" }, " Partnership Negotiations Progress Form ")
], -1))
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "w-100 px-0" }
const _hoisted_5 = { class: "mr-n2" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "text-primary my-lg-3 my-2" }, " Report any encountered challenges ", -1))
const _hoisted_7 = { class: "w-100" }
const _hoisted_8 = { class: "my-3 d-flex align-items-center" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-add-button ms-3 px-1" }, [
  /*#__PURE__*/_createElementVNode("span", null, " ")
], -1))
const _hoisted_10 = { class: "my-3 d-flex align-items-center" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-add-button ms-3 px-1" }, [
  /*#__PURE__*/_createElementVNode("span", null, " ")
], -1))
const _hoisted_12 = { class: "my-3 d-flex align-items-center" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-add-button ms-3" }, [
  /*#__PURE__*/_createElementVNode("span", null, "+")
], -1))
const _hoisted_14 = { class: "px-0" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "text-primary my-lg-3 my-2" }, " Do you require any support? ", -1))
const _hoisted_16 = { class: "d-flex justify-content-end my-3 px-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", null, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Textarea, {
              class: "w-100",
              placeholder: 'Progress with partner negotiations',
              modelValue: _ctx.test,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.test) = $event)),
              rows: "3",
              autoResize: true
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_InputText, {
                  class: "w-100 custom-input-text",
                  type: "text"
                }),
                _hoisted_9
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_InputText, {
                  class: "w-100 custom-input-text",
                  type: "text"
                }),
                _hoisted_11
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_InputText, {
                  class: "w-100 custom-input-text",
                  type: "text"
                }),
                _hoisted_13
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("div", null, [
              _createVNode(_component_Textarea, {
                class: "w-100",
                placeholder: '',
                modelValue: _ctx.test,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.test) = $event)),
                rows: "3",
                autoResize: true
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_Button, {
              label: "Submit",
              "aria-label": "Submit",
              class: "p-custom-button"
            })
          ])
        ])
      ])
    ]),
    _createVNode(_component_Footer)
  ]))
}